import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决路由重复导航报错问题
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/check'
    },
    { // 检查ip还是账户登录
      path: '/check',
      name: 'check',
      component: () => import('@/page/check/index')
    },
    { // 登录
      path: '/login',
      name: 'login',
      component: () => import('@/page/login/index')
    },
    { // 暂存架页面
      path: '/bookcase',
      name: 'bookcase',
      component: () => import('@/page/bookcase/index')
    },
    { // sci期刊搜索页
      path: '/sci-journal',
      name: 'sci-journal',
      component: () => import('@/page/sci-journal/index')
    },

    { // sci搜索页
      path: '/sci-search',
      name: 'sci-search',
      component: () => import('@/page/sci-search/index')
    },
    { // sci搜索详情页
      path: '/sci-search-detail',
      name: 'sci-search-detail',
      component: () => import('@/page/sci-search-detail/index')
    },
    { // 404页面
      path: '*',
      name: '404',
      component: () => import('@/page/404/index')
    },
    { // new-首页
      path: '/index',
      name: 'index',
      component: () => import('@/page/new-index/index')
    },
    { // new-工学
      path: '/new-academic',
      name: 'new-academic',
      component: () => import('@/page/new-academic/index')
    },
    { // new-期刊详情
      path: '/new-journal-detail',
      name: 'new-journal-detail',
      component: () => import('@/page/new-journal-detail/index')
    },
    { // new-订阅中心
      path: '/new-subscribe',
      name: 'new-subscribe',
      component: () => import('@/page/new-subscribe/index')
    },
    { // 注册账号
      path: '/registered',
      name: 'registered',
      component: () => import('@/page/registered/index')
    },
    { // 信息工程大学下载包页面
      path: '/info_download',
      name: 'info_download',
      component: () => import('@/page/info/index')
    },
    { // pdf对译页面
      path: '/pdfConTran',
      name: 'pdfConTran',
      component: () => import('@/page/pdf/index')
    },
    {
      path:'/header',
      name:'header',
      component:()=>import('../components/comHeader.vue')
    },
  ]
})








// WEBPACK FOOTER //
// ./src/router/index.js